import { BrandFeatureName } from './../features';
import { OffsetDurations } from './offset-duration';
import { Supervisor } from './supervisor';

export interface FeatureBrandConfiguration {
  id: string;
  name: string;
  agenda?: boolean;
  idStrategy?: FeatureBrandPartnerBranchIdStrategy;
  booking: FeatureBrandBooking;
  partners: FeatureBrandPartners;
  features: BrandFeatureName[];
  adminEmail?: string;
  logo: string;
  averageInterventionDuration: string;
  mobilityHalfDayLimit?: string;
  customPhone?: {
    insurer?: CustomPhoneEnv;
    customer?: CustomPhoneEnv;
  };
  supervisors: Supervisor[];
}

export interface CustomPhoneEnv {
  public?: string;
  internal?: string;
}

export interface FeatureBrandBooking {
  search: {
    version: FeatureBrandBookingSearchVersion;
    interventionZone?: string[];
    offset?: OffsetDurations;
    mobilityOffset?: OffsetDurations;
    slots?: string[];
    rangeByDays?: number;
  };
  book: { version: FeatureBrandBookingBookVersion };
  request: { version: FeatureBrandBookingBookVersion };
  cancel: { version: FeatureBrandBookingCancelVersion };
  modify: {
    version: FeatureBrandBookingModifyVersion;
    strategy: FeatureBrandBookingModifyStrategy;
  };
  specificBOCredentials?: string[];
}

export type FeatureBrandPartnerBranchIdStrategy = 'INTERNAL' | 'FCE';
export type FeatureBrandBookingSearchVersion = 'V1' | 'V2' | 'NO_SLOT' | 'MOCK';
export type FeatureBrandBookingBookVersion = 'V1' | 'V2' | 'MOCK';
export type FeatureBrandBookingRequestVersion = 'V2' | 'MOCK';
export type FeatureBrandBookingCancelVersion = 'V2' | 'MOCK';
export type FeatureBrandBookingModifyVersion = 'V2' | 'MOCK';
export type FeatureBrandBookingModifyStrategy = 'MODIFY' | 'CANCEL_AND_BOOK';

export interface FeatureBrandPartners {
  search: {
    version: FeatureBrandPartnersVersion;
    countryIdPartoo?: number;
    countryIdHorizon?: number;
    idType?: FeatureBrandPartnersIDType;
  };
  import?: {
    masterConf?: string;
    notifMail: string;
    notifMailCC?: string;
  };
}

export type FeatureBrandPartnersVersion = 'V2' | 'MOCK' | 'MASTER';
export type FeatureBrandPartnersIDType = 'HORIZON_ID' | 'PARTOO_ID';
